import { defineComponent as _defineComponent } from 'vue'
import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { BuilderDropdownOptionsEnum } from "@/enums/BuilderDropdownOptionsEnum";
  import { ref, computed, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDropdown',
  props: {
    estateSelected: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["selectEstate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const selectedEstateId = ref<string | null>(null);

  const displaySelectedTitle = computed(() => {
    const selectedOption = props.options.find(
      (option) => option.id === selectedEstateId.value
    );

    return selectedOption
      ? selectedOption.title
      : BuilderDropdownOptionsEnum.SELECT_PROJECT;
  });

  const setSelectedEstate = (option: {
    id: string;
    title: string;
    landownerId: string | null;
  }) => {
    selectedEstateId.value = option.id;
    emit("selectEstate", option.title, option.id, option.landownerId);
  };

  watch(
    () => props.estateSelected,
    (newTitle) => {
      const selectedOption = props.options.find(
        (option) => option.title === newTitle
      );

      selectedEstateId.value = selectedOption ? selectedOption.id : null;
    },
    { immediate: true }
  );

const __returned__ = { props, emit, selectedEstateId, displaySelectedTitle, setSelectedEstate, DropDown, get BuilderDropdownOptionsEnum() { return BuilderDropdownOptionsEnum }, ref, computed, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})